import { useQuery } from '@tanstack/react-query';
import { supabase } from '../services/supabase';

export interface Devotional {
  id: string;
  title: string;
  subtitle?: string;
  date?: string;
  series_id?: string;
  series?: string;
  thumbnail?: string;
  day_titles?: string[] | null;
}

export const useDevotionals = () => {
  return useQuery<Devotional[]>({
    queryKey: ['devotionals'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('devotionals')
        .select('id, title, subtitle, date, thumbnail, series_id:series_id, devotional_series(title)')
        .order('date', { ascending: false })
        .limit(500);
      if (error) throw error;

      const list = (data ?? []).map((row: any) => ({
        id: row.id,
        title: row.title,
        subtitle: row.subtitle,
        date: row.date,
        thumbnail: row.thumbnail,
        series_id: row.series_id,
        series: row.devotional_series?.title,
      })) as Devotional[];
      return list;
    },
    staleTime: 5 * 60_000,
  });
};
